<template lang="">
  <div>
    <div class="secction">
      <md-card>
        <md-card-content>
          <ValidationObserver ref="validator">
            <div class="md-layout ">
              <h4 class="md-layout-item">Group information</h4>
            </div>
            <div class="md-layout">
              <div class="md-layout-item  md-medium-size-100 md-size-60">
                <ValidationProvider name="Group name" rules="required" v-slot="{ passed, failed, errors }" slim>
                  <md-field :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]">
                    <label>Group Name</label>
                    <md-input v-model="group.name"></md-input>
                    <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
                  </md-field>
                </ValidationProvider>
              </div>
              <md-switch class="md-layout-item  md-medium-size-100 md-size-15" v-model="group.repeat">Repear group</md-switch>
              <div class="md-layout-item  md-medium-size-100 ">
                <ValidationProvider name="status" rules="required" v-slot="{ passed, failed, errors }" slim>
                  <md-field :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]">
                    <label for="movie">Status</label>
                    <md-select v-model="group.status">
                      <md-option value="TENTATIVE">Tentative</md-option>
                      <md-option value="CANCELLED">Cancelled</md-option>
                      <md-option value="CONFIRMED">Confirmed</md-option>
                    </md-select>
                    <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
                  </md-field>
                </ValidationProvider>
              </div>
            </div>
            <div class="md-layout ">
              <h4 class="md-layout-item">Group Lines</h4>
            </div>
            <template v-for="(line, index) in this.group.group_line_list">
              <div :key="'line' + index" class="md-layout group-line">
                <div class="md-layout-item  md-medium-size-100 line_label">
                  <span>Line {{ line.num_line }}</span>
                </div>
                <div class="md-layout-item  md-medium-size-100 md-size-30">
                  <date-range-picker
                    :vid="'arrival' + index"
                    :start="line.arrival_from"
                    :end="line.arrival_to"
                    @change="changeTravelDate($event, index)"
                    :min-days="1"
                    :max-days="10"
                    :displayList="false"
                    :displayFromTo="true"
                    :label_from="'Travel Window from'"
                    :label_to="'Travel Window to'"
                  ></date-range-picker>
                  <!-- <date-window v-model="line.arraival" :fixedLength="true"><template v-slot:label>Arrival</template> </date-window> -->
                </div>
                <div class="md-layout-item  md-medium-size-100 md-size-15">
                  <ValidationProvider :vid="'room' + index" name="N. Rooms" rules="required" v-slot="{ passed, failed, errors }" slim>
                    <md-field :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]">
                      <label>N. Rooms</label>
                      <md-input v-model="line.num_rooms" type="number"></md-input>
                      <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item  md-medium-size-100 md-size-25">
                  <ValidationProvider
                    :vid="'room-type' + index"
                    name="Room type"
                    :rules="'required'"
                    v-slot="{ passed, failed, errors }"
                    slim
                  >
                    <room-type-select
                      :vid="'room-type' + index"
                      v-model="line.room_type_id"
                      :passed="passed"
                      :failed="failed"
                      :errors="errors"
                    ></room-type-select>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item  md-medium-size-100 md-size-22">
                  <ValidationProvider :vid="'board' + index" name="Room type" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
                    <board-select
                      :vid="'board' + index"
                      v-model="line.board_id"
                      :required="true"
                      :passed="passed"
                      :failed="failed"
                      :errors="errors"
                    ></board-select>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item  md-medium-size-100 md-size-20">
                  <ValidationProvider :vid="'pax' + index" name="Room type" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
                    <pax-combination-select
                      :vid="'pax' + index"
                      v-model="line.pax_combination_code"
                      :passed="passed"
                      :failed="failed"
                      :errors="errors"
                    ></pax-combination-select>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item  md-medium-size-100 md-size-20">
                  <ValidationProvider
                    :vid="'comp-room' + index"
                    name="Comp rooms"
                    rules="required"
                    v-slot="{ passed, failed, errors }"
                    slim
                  >
                    <md-field :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]">
                      <label>Complementary Rooms</label>
                      <md-input v-model="line.comp_rooms" type="number"></md-input>
                      <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item  md-medium-size-100 md-size-5" style="display:flex; align-items:center">
                  <div :style="`height: 24px; width: 24px; border-radius: 24px; background-color: ${line.line_color};`"></div>
                </div>
                <div class="md-layout-item  md-medium-size-100 ">
                  <md-button v-if="Math.max(1, group.group_line_list.length) > 1" @click="deleteLine(index)" class="md-white md-just-icon"
                    ><md-icon>delete</md-icon></md-button
                  >
                  <md-button v-if="index + 1 == Math.max(1, group.group_line_list.length)" @click="addNewLine" class="md-white md-just-icon"
                    ><md-icon>add</md-icon></md-button
                  >
                </div>
              </div>
            </template>
            <div class="md-layout">
              <h4 class="md-layout-item">Others</h4>
            </div>
            <div class="md-layout">
              <div class="md-layout-item  md-medium-size-100">
                <md-field>
                  <label>Extras</label>
                  <md-input v-model="group.extras" type="number"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item  md-medium-size-100">
                <md-field>
                  <label>F&B</label>
                  <md-input v-model="group.food_beverage" type="number"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item  md-medium-size-100">
                <md-field>
                  <label>Metting rooms</label>
                  <md-input v-model="group.metting_rooms" type="number"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item  md-medium-size-100">
                <md-field>
                  <label>Commission %</label>
                  <md-input v-model="group.commission" type="number"></md-input>
                </md-field>
              </div>
            </div>
          </ValidationObserver>
        </md-card-content>
        <md-card-actions>
          <md-button v-if="!show_prices" @click="$router.back()">Cancel</md-button>
          <md-button v-if="checkRole()" class="md-success" @click="saveGroup">Save</md-button>
        </md-card-actions>
      </md-card>
    </div>
    <div class="secction" v-if="show_prices">
      <md-card>
        <md-card-content>
          <div class="md-layout ">
            <h4 class="md-layout-item">Prices Lines</h4>
          </div>
          <template v-for="(line, index) in group.group_line_price_list">
            <div :key="'line' + index" class="md-layout">
              <div class="md-layout-item  md-medium-size-100  line-label">
                <span>Line {{ index + 1 }}</span>
              </div>
              <div class="md-layout-item  md-medium-size-100">
                <md-field>
                  <label>N. Rooms</label>
                  <md-input v-model="line.num_rooms" type="number" disabled></md-input>
                </md-field>
              </div>
              <!-- <div class="md-layout-item  md-medium-size-100">
                <md-field>
                  <label>Minimum Price</label>
                  <md-input v-model="line.min_price" type="number"></md-input>
                </md-field>
              </div> -->
              <div class="md-layout-item  md-medium-size-100">
                <md-field>
                  <label>Recomended Price</label>
                  <md-input v-model="line.recomended_price" type="number" disabled></md-input>
                </md-field>
              </div>
              <div class="md-layout-item  md-medium-size-100">
                <md-field>
                  <label>UserPrice</label>
                  <md-input v-model="line.user_price" type="number"></md-input>
                </md-field>
              </div>
            </div>
          </template>
          <div class="md-layout md-alignment-center-space-between" style="font-weight:bold">
            <span class="md-layout-item md-medium-size-100 md-size-20">Total Lines</span>
            <span class="md-layout-item">{{ getTotalLines }} {{ currency }}</span>
            <span class="md-layout-item md-medium-size-100 md-size-20">Displacement</span>
            <span class="md-layout-item">{{ group.displacement }} {{ currency }}</span>
          </div>
          <div class="md-layout ">
            <h4 class="md-layout-item">Alternative Dates</h4>
          </div>
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-card-calendar">
              <full-calendar
                ref="calendar"
                defaultView="dayGridMonth"
                :height="500"
                :selectable="true"
                :defaultDate="getDefaultDate"
                :header="header"
                :buttonIcons="buttonIcons"
                :plugins="calendarPlugins"
                :showNonCurrentDates="false"
                :events="eventCalendar"
                @eventClick="eventClick"
              ></full-calendar>
            </div>
          </div>
          <div class="md-layout ">
            <h4 class="md-layout-item">Alternative Hotels</h4>
          </div>
          <template v-for="(hotel, index) in group.alternative_hotels">
            <div :key="'hotel' + index" class="md-layout">
              <span class="md-layout-item">{{ hotel.name + ' ' + index }}</span>
            </div>
          </template>

          <!-- <ValidationObserver ref="validator_prices">
            <div class="md-layout ">
              <h4 class="md-layout-item">Emails destinations</h4>
            </div>
            <template v-for="(email, index) in this.group.email_destination">
              <div :key="'email' + index" class="md-layout" style="padding:15px 0px">
                <div class="md-layout-item  md-medium-size-100 md-size-20">
                  <ValidationProvider :name="`email ${index + 1}`" :rules="'required|email'" v-slot="{ passed, failed, errors }" slim>
                    <md-field :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]">
                      <label>Email {{ index + 1 }}</label>
                      <md-input v-model="group.email_destination[index]" type="email"></md-input>
                      <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item  md-medium-size-100 ">
                  <md-button
                    v-if="Math.max(1, group.email_destination.length) > 1"
                    @click="deleteEmail(index)"
                    class="md-white md-just-icon"
                    ><md-icon>delete</md-icon></md-button
                  >
                  <md-button
                    v-if="index + 1 == Math.max(1, group.email_destination.length)"
                    @click="addNewEmail"
                    class="md-white md-just-icon"
                    ><md-icon>add</md-icon></md-button
                  >
                </div>
              </div>
            </template>
          </ValidationObserver> -->
        </md-card-content>
        <md-card-actions>
          <md-button @click="$router.back()">Cancel</md-button>
          <md-button class="md-success" @click="exportToExcel">Export to excel</md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate'
import { extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import DateRangePicker from '@/components/Inputs/DateRangePicker.vue'
import BoardSelect from '@/components/Inputs/BoardSelect.vue'
import RoomTypeSelect from '@/components/Inputs/RoomTypeSelect.vue'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import PaxCombinationSelect from '@/components/Inputs/PaxCombinationSelect.vue'
import Currency from '@/utils/Currency'
import Swal from 'sweetalert2'

import { GroupApi, GroupDetailDTO, GroupLineDTO } from '@/openapi/src'

const groupApi = new GroupApi()

extend('email', email)
extend('required', required)

const lineColorMap = {
  1: '#785964',
  2: '#E86492',
  3: '#E86D64',
  4: '#64A5E8',
  5: '#1AF076',
  6: '#708193',
  7: '#E8B764',
  8: '#459B6A',
  9: '#447049',
  10: '#90F00E',
}

let currency

export default {
  name: 'Group',
  components: {
    ValidationProvider,
    DateRangePicker,
    RoomTypeSelect,
    BoardSelect,
    FullCalendar,
    PaxCombinationSelect,
  },
  data() {
    return {
      id: null,
      show_prices: false,
      group: {},
      header: {
        right: 'prev,next,today',
      },
      calendarPlugins: [dayGridPlugin],
      buttonIcons: {
        close: 'fa-times',
        prev: 'left-single-arrow',
        next: 'right-single-arrow',
        prevYear: 'fa-angle-double-left',
        nextYear: 'fa-angle-double-right',
      },
    }
  },
  created() {
    this.currency = Currency[sessionStorage.getItem('currency')]
    this.id = this.$route.params.id
    this.group = GroupDetailDTO.constructFromObject({
      hotel_id: this.$root.hotelId,
      repeat: false,
      status: 'TENTATIVE',
      extras: 0,
      food_beverage: 0,
      metting_rooms: 0,
      commission: 0,
      displacement: 0,
      alternative_hotels: [],
      email_destination: [],
      group_line_list: [
        GroupLineDTO.constructFromObject({
          hotel_id: this.$root.hotelId,
          group_id: this.id,
          num_line: 1,
          comp_rooms: 0,
          arrival_from: null,
          arrival_to: null,
          line_color: lineColorMap[1],
        }),
      ],
    })
    if (!!this.id) {
      groupApi.getGroupById(this.$root.hotelId, this.id, (error, group) => {
        if (!error) {
          this.group = group
          this.id = group.id
          if (!!this.group.group_alternative_price_list) {
            if (this.group.email_destination?.length == 0) {
              this.group.email_destination.push('')
            }
            this.$nextTick(() => (this.show_prices = true))
          }
        }
      })
    }
  },
  methods: {
    checkRole() {
      return this.$root.hasBackendRole('group')
    },
    changeTravelDate(range, index) {
      this.group.group_line_list[index].arrival_from = range.start
      this.group.group_line_list[index].arrival_to = range.end
    },
    async saveGroup() {
      const isValid = await this.$refs.validator.validate()

      if (isValid) {
        groupApi.createGroupById(this.$root.hotelId, this.group, (error, group) => {
          if (!error) {
            this.group = group
            this.id = group.id

            this.$nextTick(() => (this.show_prices = true))
          }
        })
      } else {
        this.$notify({
          timeout: 2500,
          message: '<strong>Not saved</strong>. Please check your inputs',
          icon: 'check_box',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: 'danger',
        })
      }
    },
    saveAndSendMail() {},
    exportToExcel() {
      let auth = groupApi.apiClient.authentications['bearer-token']
      let token = typeof auth.accessToken === 'function' ? auth.accessToken() : auth.accessToken

      let url = groupApi.apiClient.buildUrl(
        `/group/${this.$root.hotelId}/${this.id}/excel`,
        {
          hotelId: this.$root.hotelId,
        },
        null
      )

      fetch(url, {
        method: 'GET',
        headers: new Headers({
          Authorization: 'Bearer ' + token,
          accept: 'application/octet-stream',
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.blob()
          } else {
            throw new Error('Error al generer el fichero')
          }
        })
        .then((blob) => {
          var url = window.URL.createObjectURL(blob)
          var a = document.createElement('a')
          a.href = url
          a.download = `Detalle_Grupo_${this.id}.xlsx`
          document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click()
          a.remove() //afterwards we remove the element again
        })
        .catch((error) => {
          return Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
          })
        })
    },
    showPrices() {
      this.$router.push(`/groups-list/group/${this.id}/prices`)
    },
    addNewLine() {
      if (this.group.group_line_list.length < 10) {
        this.group.group_line_list.push(
          GroupLineDTO.constructFromObject({
            hotel_id: this.$root.hotelId,
            group_id: this.id,
            num_line: this.group.group_line_list.length + 1,
            arrival_from: null,
            arrival_to: null,
            line_color: lineColorMap[this.group.group_line_list.length + 1],
          })
        )
      }
    },
    deleteLine(index) {
      this.$delete(this.group.group_line_list, index)
      this.group.group_line_list.map((group_line, index) => {
        group_line.num_line = index + 1
        group_line.line_color = lineColorMap[index + 1]
      })
    },
    addNewEmail() {
      this.group.email_destination.push('')
    },
    deleteEmail(index) {
      this.$delete(this.group.email_destination, index)
    },
    eventClick(eventClickInfo) {
      console.log(eventClickInfo)
    },
  },
  computed: {
    eventCalendar() {
      return this.group.group_alternative_price_list?.map((e) => {
        return {
          //id: e.id,
          title: e.min_price + '€',
          allDay: true,
          start: e.alternative_date,
          backgroundColor: e.line_color,
        }
      })
    },
    getDefaultDate() {
      return this.group.group_line_list.find((line) => line.num_line === 1).arrival_from
    },
    getTotalLines() {
      return this.group.total_price
    },
  },
}
</script>
<style lang="scss">
.secction {
  padding: 25px 20px;
}

.group-line {
  margin-top: 10px;
}

.line_label {
  width: 70px;
  flex: 0 1 70px;
  display: flex;
  align-items: center;
}

.md-field .md-error {
  bottom: -10px;
}

.fc-bg {
  .fc-day {
    &.partial_closed {
      background: repeating-linear-gradient(45deg, rgb(247, 231, 209) 10px, rgb(252, 246, 238) 10px, rgb(242, 215, 180) 20px);
    }
    &.closed {
      background: repeating-linear-gradient(#f2d7b4, #f2d7b4);
    }
    position: relative;
    .fc-widget-content-bottom {
      position: absolute;
      text-align: center;
      width: 100%;
      bottom: 0;
      padding: 0 5px;
      font-size: 0.8em;
      background-color: rgba(255, 255, 255, 0.6);
    }
  }
}
</style>
